import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoggingService } from '../../services/logging.service';
import { ManagerDashboardService } from '../../services/manager-dashboard.service';
import { Assignment } from '../../models/assignment';
import { Subscription } from 'rxjs';
import { Team } from '../../models/team';
import { User } from '../../models/user';
import { UserTagsResponse } from '../../models/userTagResponse';

@Component({
  selector: 'app-view-progress',
  standalone: false,
  templateUrl: './view-progress.component.html',
  styleUrl: './view-progress.component.scss'
})
export class ViewProgressComponent implements OnInit, OnDestroy {

  managerId !: number;
  selectedTeam !: number;
  teamSubscription !: Subscription;
  teams : Team[] = [];
  userTags : UserTagsResponse[] = [];
  userTagsSubscription !: Subscription;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
   progressPercent: number = 0;

  constructor(private loggingService : LoggingService, 
              private managerDashboardService : ManagerDashboardService) { }

  ngOnInit() {
    this.loggingService.logDebug("Getting the managerId from session storage");
    const manager_id = sessionStorage.getItem('manager_id');
    if(manager_id) {
      this.managerId = parseInt(manager_id, 10);
    }

    this.teamSubscription = this.managerDashboardService.getAllTeams(this.managerId).subscribe(
      (teams) => {
        this.teams = teams;
      
        if (this.teams.length > 0 ) {
          this.selectedTeam = this.teams[0].teamId;
         
          this.onTeamOrAssignmentChange();
        }

     } ); 

  }

  onTeamOrAssignmentChange() {
    const teamId = Number(this.selectedTeam);
    if (teamId) {
      this.userTagsSubscription =
        this.managerDashboardService.getAllUsersWithStatusByManagerIdAndTeamIdAndAssigmentId(this.managerId, teamId)
          .subscribe((response: any) => {
            this.progressPercent = response.progressPercent;
            this.userTags = response.users.map((userTag: any) => {
            if (userTag.status?.toLowerCase() === 'completed') {
              userTag.daysLeft = 0;
            }
            return userTag;
          });
    });
    }
  }
  
  sortData(column: string) {
  if (this.sortColumn === column) {
    // toggle direction
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  this.userTags.sort((a: any, b: any) => {
    const valA = this.getValue(a, column);
    const valB = this.getValue(b, column);

    if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
    if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
}

  getValue(obj: any, column: string) {
  switch (column) {
    case 'username': return obj.user?.Name?.toLowerCase() || '';
    case 'status': return obj.status?.toLowerCase() || '';
    case 'assignedDate': return new Date(obj.assignedDate).getTime();
    case 'completionDate': return obj.completionDate ? new Date(obj.completionDate).getTime() : 0;
    case 'targetCompletionDate': return new Date(obj.targetCompletionDate).getTime();
    case 'daysLeft': return obj.daysLeft || 0;
    case 'overdue': return obj.overdue ? 1 : 0;
    default: return '';
  }
}
  sendReminder(userTag: UserTagsResponse) {
    alert(`Reminder sent to ${userTag.user.Name}`);
  }

  ngOnDestroy() {
    this.teamSubscription.unsubscribe();
    this.userTagsSubscription.unsubscribe();
  }

  

}
